var impressum = "Impressos";
var privacy = "Política de privacidade e informações legais";
var recallInfo = "Informações de recolha";
var signOut = "Terminar sessão";
var pt_pt = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { pt_pt as default, impressum, privacy, recallInfo, signOut };
